import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SignalEventsService {
  signingOut = signal<boolean>(false);
  signedOut = signal<boolean>(false);

  constructor() {}
}
